/* eslint-disable import/no-duplicates */
// Icons
import Arkade from "assets/icons/glory/menu_arkada.svg?react";
import Bakkara from "assets/icons/glory/menu_bakkara.svg?react";
import Blackjack from "assets/icons/glory/menu_blackjack.svg?react";
import Bingo from "assets/icons/glory/menu_bingo.svg?react";
import Favorite from "assets/icons/glory/menu_favorite.svg?react";
import Momentum from "assets/icons/glory/menu_momentum.svg?react";
import Lottery from "assets/icons/glory/menu_lottery.svg?react";
import Keno from "assets/icons/glory/menu_keno.svg?react";
import VideoPoker from "assets/icons/glory/menu_video-poker.svg?react";
import Popular from "assets/icons/glory/menu_popular.svg?react";
import Poker from "assets/icons/glory/menu_poker.svg?react";
import Roulette from "assets/icons/glory/menu_roulette.svg?react";
import Other from "assets/icons/glory/menu_other.svg?react";
import Slots from "assets/icons/glory/menu_slots.svg?react";
import Skretch from "assets/icons/glory/menu_skretch.svg?react";
import Table from "assets/icons/glory/menu_table.svg?react";
import Crash from "assets/icons/glory/menu_crash.svg?react";

// Images
import ArkadeImg from "assets/icons/glory/menu_arkada.svg";
import BakkaraImg from "assets/icons/glory/menu_bakkara.svg";
import BlackjackImg from "assets/icons/glory/menu_blackjack.svg";
import BingoImg from "assets/icons/glory/menu_bingo.svg";
import FavoriteImg from "assets/icons/glory/menu_favorite.svg";
import MomentumImg from "assets/icons/glory/menu_momentum.svg";
import LotteryImg from "assets/icons/glory/menu_lottery.svg";
import KenoImg from "assets/icons/glory/menu_keno.svg";
import VideoPokerImg from "assets/icons/glory/menu_video-poker.svg";
import PopularImg from "assets/icons/glory/menu_popular.svg";
import PokerImg from "assets/icons/glory/menu_poker.svg";
import RouletteImg from "assets/icons/glory/menu_roulette.svg";
import OtherImg from "assets/icons/glory/menu_other.svg";
import SlotsImg from "assets/icons/glory/menu_slots.svg";
import SkretchImg from "assets/icons/glory/menu_skretch.svg";
// import VSportImg from "assets/icons/glory/menu_vsport.svg";
import TableImg from "assets/icons/glory/menu_table.svg";
import CrashImg from "assets/icons/glory/menu_crash.svg";

// Url
import url from "url/index";

export enum CATEGORIES_ENUMS {
  POPULAR = "popular",
  FAVORITE = "favorite",
  SLOTS = "slots",
  TABLE = "table-games",
  // TABLE = "table", for gamesV1
  LOTTERY = "lottery",
  VIDEO_POKER = "video-poker",
  ROULETTE = "roulette",
  BLACKJACK = "black-jack",
  // BLACKJACK = "blackjack", for gamesV1
  SCRATCH = "scratch-cards",
  // SCRATCH = "scratch card", for gamesV1
  POKER = "poker",
  BINGO = "bingo",
  // VSPORT = "virtual-sport",
  BACCARA = "baccara",
  // BACCARA = "baccarat", for gamesV1
  ARKADE = "arcade",
  KENO = "keno",
  INSTANT = "instant-games",
  // INSTANT = "instant", for gamesV1
  LIVE_CASINO = "live-casino",
  TV_GAMES = "tv-games",
  OTHER = "other",
  CRASH = "crash",
}

export const CATEGORIES_WITH_SPACE = [
  CATEGORIES_ENUMS.TABLE,
  CATEGORIES_ENUMS.VIDEO_POKER,
  CATEGORIES_ENUMS.BLACKJACK,
  CATEGORIES_ENUMS.SCRATCH,
  CATEGORIES_ENUMS.INSTANT,
];

export const POPULAR_CATEGORIES = [
  {
    id: CATEGORIES_ENUMS.POPULAR,
    title: "casino.sidebar.popular",
    icon: <Popular />,
    image: PopularImg,
    url: url.routes.casino.index(),
  },
  {
    id: CATEGORIES_ENUMS.FAVORITE,
    title: "casino.sidebar.favorite",
    icon: <Favorite />,
    image: FavoriteImg,
    url: url.routes.casino.favorites(),
  },
];

export const CATEGORIES = [
  {
    id: CATEGORIES_ENUMS.SLOTS,
    title: "casino.sidebar.slots",
    icon: <Slots />,
    image: SlotsImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.SLOTS),
  },
  {
    id: CATEGORIES_ENUMS.CRASH,
    title: "casino.sidebar.crash",
    icon: <Crash />,
    image: CrashImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.CRASH),
  },
  {
    id: CATEGORIES_ENUMS.TABLE,
    title: "casino.sidebar.table",
    icon: <Table />,
    image: TableImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.TABLE),
  },
  {
    id: CATEGORIES_ENUMS.LOTTERY,
    title: "casino.sidebar.lottery",
    icon: <Lottery />,
    image: LotteryImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.LOTTERY),
  },
  {
    id: CATEGORIES_ENUMS.VIDEO_POKER,
    title: "casino.sidebar.poker.video",
    icon: <VideoPoker />,
    image: VideoPokerImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.VIDEO_POKER),
  },
  {
    id: CATEGORIES_ENUMS.ROULETTE,
    title: "casino.sidebar.poker.roulette",
    icon: <Roulette />,
    image: RouletteImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.ROULETTE),
  },
  {
    id: CATEGORIES_ENUMS.BLACKJACK,
    title: "casino.sidebar.poker.blackjack",
    icon: <Blackjack />,
    image: BlackjackImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.BLACKJACK),
  },
  {
    id: CATEGORIES_ENUMS.SCRATCH,
    title: "casino.sidebar.poker.scratch",
    icon: <Skretch />,
    image: SkretchImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.SCRATCH),
  },
  {
    id: CATEGORIES_ENUMS.POKER,
    title: "casino.sidebar.poker.poker",
    icon: <Poker />,
    image: PokerImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.POKER),
  },
  {
    id: CATEGORIES_ENUMS.BINGO,
    title: "casino.sidebar.poker.bingo",
    icon: <Bingo />,
    image: BingoImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.BINGO),
  },
  // {
  //   id: CATEGORIES_ENUMS.VSPORT,
  //   title: "casino.sidebar.poker.sport",
  //   icon: <VSport />,
  //   image: VSportImg,
  //   url: url.routes.casino.category(CATEGORIES_ENUMS.VSPORT),
  // },
  {
    id: CATEGORIES_ENUMS.BACCARA,
    title: "casino.sidebar.poker.bakkara",
    icon: <Bakkara />,
    image: BakkaraImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.BACCARA),
  },
  {
    id: CATEGORIES_ENUMS.ARKADE,
    title: "casino.sidebar.poker.arcade",
    icon: <Arkade />,
    image: ArkadeImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.ARKADE),
  },
  {
    id: CATEGORIES_ENUMS.KENO,
    title: "casino.sidebar.poker.keno",
    icon: <Keno />,
    image: KenoImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.KENO),
  },
  {
    id: CATEGORIES_ENUMS.INSTANT,
    title: "casino.sidebar.poker.instant",
    icon: <Momentum />,
    image: MomentumImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.INSTANT),
  },
  {
    id: CATEGORIES_ENUMS.OTHER,
    title: "casino.sidebar.poker.other",
    icon: <Other />,
    image: OtherImg,
    url: url.routes.casino.category(CATEGORIES_ENUMS.OTHER),
  },
];

export const CATEGORIES_LIVE = [
  {
    id: CATEGORIES_ENUMS.LIVE_CASINO,
    title: "casino.top.livecasino",
    icon: null,
    url: url.routes.casino.category(CATEGORIES_ENUMS.LIVE_CASINO),
  },
];

export const CATEGORIES_FOR_SEO = {
  [CATEGORIES_ENUMS.SLOTS]: "Slot Machine",
  [CATEGORIES_ENUMS.TABLE]: "Table Games",
  [CATEGORIES_ENUMS.LOTTERY]: "Lottery",
  [CATEGORIES_ENUMS.VIDEO_POKER]: "Video Poker",
  [CATEGORIES_ENUMS.ROULETTE]: "Roulette",
  [CATEGORIES_ENUMS.BLACKJACK]: "Black Jack",
  [CATEGORIES_ENUMS.SCRATCH]: "Scratch cards",
  [CATEGORIES_ENUMS.POKER]: "Poker",
  [CATEGORIES_ENUMS.BINGO]: "Bingo",
  // [CATEGORIES_ENUMS.VSPORT]: "VSport",
  [CATEGORIES_ENUMS.BACCARA]: "Baccara",
  [CATEGORIES_ENUMS.ARKADE]: "Arcade",
  [CATEGORIES_ENUMS.KENO]: "Keno",
  [CATEGORIES_ENUMS.INSTANT]: "Instant Games",
  [CATEGORIES_ENUMS.OTHER]: "Other Game",
};
